import React, { useEffect, useState } from "react";
import SeraloginOnlineCard from "../../components/seraloginOnline/card/seraloginOnlineCard.js";
import SeraloginOnlineContainer from "../../components/seraloginOnline/containers/SeraloginOnlineContainer.js";
import { Box, Grid } from "@mui/material";
import AnnualBudgetTable from "../../components/seraloginOnline/annualBudgetTable/index.js";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import SimpleSelect from "../../components/selects/simpleSelect/index.js";
import { months, years } from "../../constants/selectData.js";
import {
  getCurrentMonth,
  getCurrentYear,
  getMonthName
} from "../../utils/dateUtils.js";
import TabSelectButtonGroup from "../../components/seraloginOnline/tabSelectButtonGroup/index.js";
import {
  callApiAsync,
  getPortfolioStatusReportData,
  getProductPerformanceIndicatorData,
  getSalesPerformanceData
} from "../../services/apiService.js";
import { formatWithDots, moneyTransform } from "../../utils/utilsFunctions.js";
import "./styles.css";
import { getCookie } from "../../utils/getCookie.js";

const validationSchema = yup.object({
  monthFilter: yup.string().required("El mes es obligatorio"),
  yearFilter: yup.string().required("El año es obligatorio")
});

const SeraloginOnline = () => {
  const [selectedTab, setSelectedTab] = useState("EMULSION 20");
  const [selectedTabII, setSelectedTabII] = useState("VENTASMENSUALES");

  const [carteraData, setCarteraData] = useState({});
  const [IndicadorProductosData, setIndicadorProductosData] = useState([]);
  const [IndicadorVentasData, setIndicadorVentasData] = useState([]);

  const userSesion = getCookie("sesion");
  const userId = userSesion?.id_usuario;

  const optionsProductPerformanceIndicator = [
    { value: "EMULSION 20", label: "Serafol 20ml" },
    { value: "EMULSION 50", label: "Serafol 50ml" },
    { value: "ialuril", label: "Ialurill" },
    { value: "REMIFENTANILO 2 MG CJ X 5", label: "Remitenfanil" }
  ];

  const optionsSalesPerformanceIndicator = [
    { value: "VENTASMENSUALES", label: "VENTAS MENSUALES" },
    { value: "VENTASACUMULADAS", label: "VENTAS ACUMULADAS" }
  ];

  const {
    control,
    formState: { errors },
    getValues,
    reset,
    setValue,
    handleSubmit,
    watch
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues: {
      monthFilter: getCurrentMonth(),
      yearFilter: getCurrentYear()
    }
  });

  const yearSelected = watch("yearFilter");
  const monthSelected = watch("monthFilter");

  const findMonthRow = (data, monthName) => {
    if (typeof monthName !== "string") return {};
    return (
      data.find((r) => r.name?.toLowerCase() === monthName.toLowerCase()) || {}
    );
  };

  const productoMesData = React.useMemo(
    () => findMonthRow(IndicadorProductosData, getMonthName(monthSelected)),
    [IndicadorProductosData, getMonthName(monthSelected)]
  );

  const ventasMesData = React.useMemo(
    () => findMonthRow(IndicadorVentasData, getMonthName(monthSelected)),
    [IndicadorVentasData, monthSelected]
  );

  const getPortfolioStatusReport = async () => {
    const filters = getValues();
    await callApiAsync(
      () =>
        getPortfolioStatusReportData(filters.monthFilter, filters.yearFilter),
      (data) => {
        setCarteraData(data);
      }
    );
  };

  const getProductPerformanceIndicator = async (product) => {
    const filters = getValues();
    await callApiAsync(
      () =>
        getProductPerformanceIndicatorData(
          product,
          filters.monthFilter,
          filters.yearFilter
        ),
      (data) => {
        setIndicadorProductosData(data);
      }
    );
  };

  const getSalesPerformanceIndicator = async (indicator) => {
    const filters = getValues();
    await callApiAsync(
      () =>
        getSalesPerformanceData(
          indicator,
          filters.monthFilter,
          filters.yearFilter
        ),
      (data) => {
        setIndicadorVentasData(data);
      }
    );
  };

  useEffect(() => {
    setValue("yearFilter", getCurrentYear());
    setValue("monthFilter", getCurrentMonth());
  }, []);

  useEffect(() => {
    getPortfolioStatusReport();
    getProductPerformanceIndicator(selectedTab);
    getSalesPerformanceIndicator(selectedTabII);
  }, [yearSelected]);

  useEffect(() => {
    getPortfolioStatusReport();
    getProductPerformanceIndicator(selectedTab);
    getSalesPerformanceIndicator(selectedTabII);
  }, [monthSelected]);

  useEffect(() => {
    getSalesPerformanceIndicator(selectedTabII);
  }, [selectedTabII]);

  useEffect(() => {
    getProductPerformanceIndicator(selectedTab);
  }, [selectedTab]);

  if (!userId) {
    return <></>;
  }
  return (
    <>
      <div>
        <>
          <form className="mt-20">
            <Grid
              justifyContent="flex-start"
              alignItems={"center"}
              container
              spacing={1}
            >
              <Grid item xs={12} md={3.2}>
                <p className="so-title no-wrap">Seleccionar año y mes</p>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className="mid-filter-margin">
                  <SimpleSelect
                    name="monthFilter"
                    control={control}
                    label="Mes"
                    options={months}
                    error={!!errors.monthFilter}
                    helperText={errors.monthFilter?.message}
                    margin={"0"}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <SimpleSelect
                  name="yearFilter"
                  control={control}
                  label="Año"
                  options={years}
                  error={!!errors.yearFilter}
                  helperText={errors.yearFilter?.message}
                  margin={"0"}
                />
              </Grid>
            </Grid>
          </form>
        </>
        <Grid container spacing={2} justifyContent="center">
          {/* Columna izquierda: Cartera + Productos */}
          <Grid item xs={12} md={6}>
            {/* Indicador Cartera */}
            <p className="so-title">
              Indicador Cartera {getMonthName(monthSelected)} {yearSelected}
            </p>
            <SeraloginOnlineContainer>
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} md={4}>
                  <SeraloginOnlineCard
                    label="Presupuesto de cobros"
                    value={`${moneyTransform(
                      carteraData.totalPresupuesto || "-"
                    )}`}
                    bgColor="#F5F5F5"
                    labelColor="#4444B2"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <SeraloginOnlineCard
                    label="Ejecutado"
                    value={`${moneyTransform(
                      carteraData.totalEjecutado || "-"
                    )}`}
                    bgColor="#DDF3FF"
                    labelColor="#067BBA"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <SeraloginOnlineCard
                    label="Cumplimiento"
                    value={`${carteraData.cumplimientoTotal?.toFixed(0) || "-"}%`}
                    bgColor="#E9FFE2"
                    labelColor="#55B435"
                  />
                </Grid>
              </Grid>
            </SeraloginOnlineContainer>

            {/* Indicador Productos */}
            <p className="so-title">
              Indicador Productos {getMonthName(monthSelected)} {yearSelected}
            </p>
            <SeraloginOnlineContainer>
              <TabSelectButtonGroup
                options={optionsProductPerformanceIndicator}
                selected={selectedTab}
                onChange={setSelectedTab}
              />
              <br />
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Presupuesto"
                    value={formatWithDots(productoMesData?.presupuesto) || 0}
                    bgColor="#F5F5F5"
                    labelColor="#4444B2"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Ejecutado"
                    value={formatWithDots(productoMesData?.ejecutado) || 0}
                    bgColor="#e0f7ff"
                    labelColor="#0091ea"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Real"
                    value={`${productoMesData?.cumplimiento || 0}%`}
                    bgColor="#fff3cd"
                    labelColor="#ff9800"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Meta"
                    value={productoMesData?.meta || "95%"}
                    bgColor="#e0ffe0"
                    labelColor="#4caf50"
                  />
                </Grid>
              </Grid>
              <br />

              <Box
                sx={{
                  overflowX: "auto",
                  width: "100%"
                }}
              >
                <Box sx={{ minWidth: "700px", maxWidth: "1000px", mx: "auto" }}>
                  <AnnualBudgetTable
                    type="units"
                    data={IndicadorProductosData}
                    highlightMonth={getMonthName(monthSelected)}
                  />
                </Box>
              </Box>
            </SeraloginOnlineContainer>
          </Grid>

          {/* Columna derecha: Ventas */}
          <Grid item xs={12} md={6}>
            <p className="so-title">
              Indicador de Ventas {getMonthName(monthSelected)} {yearSelected}
            </p>
            <SeraloginOnlineContainer>
              <TabSelectButtonGroup
                options={optionsSalesPerformanceIndicator}
                selected={selectedTabII}
                onChange={setSelectedTabII}
              />
              <br />
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Presupuesto"
                    value={moneyTransform(ventasMesData.presupuesto) || "–"}
                    bgColor="#F5F5F5"
                    labelColor="#4444B2"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Ejecutado"
                    value={moneyTransform(ventasMesData.ejecutado) || "–"}
                    bgColor="#e0f7ff"
                    labelColor="#0091ea"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Real"
                    value={`${ventasMesData.cumplimiento?.toFixed(2) || 0}%`}
                    bgColor="#fff3cd"
                    labelColor="#ff9800"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SeraloginOnlineCard
                    label="Meta"
                    value={ventasMesData.meta || "95%"}
                    bgColor="#e0ffe0"
                    labelColor="#4caf50"
                  />
                </Grid>
              </Grid>
              <br />

              <Box
                sx={{
                  overflowX: "auto",
                  width: "100%"
                }}
              >
                <Box sx={{ minWidth: "700px", maxWidth: "1000px", mx: "auto" }}>
                  <AnnualBudgetTable
                    data={IndicadorVentasData}
                    highlightMonth={getMonthName(monthSelected)}
                    showAnnual={selectedTabII === "VENTASACUMULADAS" ? false :true}
                    showQuarter={selectedTabII === "VENTASACUMULADAS" ? false :true}
                    type='percent2dec'
                  />
                </Box>
              </Box>
            </SeraloginOnlineContainer>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SeraloginOnline;
